// Static Data API service for Happy Steels website
// This replaces Google Sheets with in-memory data storage

// Mock data storage - all data is stored in memory
let mockData = {
  products: [
    {
      _id: '1',
      name: 'Premium GI Door Frame',
      description: 'High-quality galvanised iron door frame with superior corrosion resistance. Perfect for residential and commercial buildings. Manufactured with precision engineering and tested for durability.',
      price: 2850,
      category: 'door-frames',
      images: ['/images/products/1.png', '/images/products/2.png'],
      featured: true,
      inStock: true,
      specifications: {
        material: 'Galvanised Iron',
        grade: 'IS 1079',
        thickness: '1.2mm',
        finish: 'Zinc Coated',
        warranty: '10 Years'
      },
      createdAt: new Date('2024-01-15').toISOString()
    },
    {
      _id: '2',
      name: 'Heavy Duty Window Frame',
      description: 'Industrial strength galvanised window frames designed for maximum durability and weather resistance. Suitable for high-rise buildings and coastal areas.',
      price: 1950,
      category: 'window-frames',
      images: ['/images/products/2.png', '/images/products/1.png'],
      featured: true,
      inStock: true,
      specifications: {
        material: 'Galvanised Iron',
        grade: 'IS 1079',
        thickness: '1.0mm',
        finish: 'Hot Dip Galvanised',
        warranty: '8 Years'
      },
      createdAt: new Date('2024-01-20').toISOString()
    },
    {
      _id: '3',
      name: 'Ventilation Grille System',
      description: 'Advanced GI ventilation grilles with optimal airflow design. Perfect for maintaining air circulation in commercial and residential spaces.',
      price: 1200,
      category: 'ventilation',
      images: ['/images/products/1.png'],
      featured: false,
      inStock: true,
      specifications: {
        material: 'Galvanised Iron',
        grade: 'Commercial Grade',
        size: 'Multiple Sizes Available',
        finish: 'Powder Coated',
        warranty: '5 Years'
      },
      createdAt: new Date('2024-02-01').toISOString()
    },
    {
      _id: '4',
      name: 'Security Door Frame',
      description: 'Extra strong galvanised iron security door frames with reinforced construction. Ideal for main entrances and high-security applications.',
      price: 3500,
      category: 'door-frames',
      images: ['/images/products/2.png'],
      featured: true,
      inStock: true,
      specifications: {
        material: 'Heavy Duty GI',
        grade: 'IS 1079 Grade A',
        thickness: '1.6mm',
        finish: 'Anti-Rust Coating',
        warranty: '12 Years'
      },
      createdAt: new Date('2024-02-10').toISOString()
    },
    {
      _id: '5',
      name: 'Standard Window Frame',
      description: 'Cost-effective galvanised window frames for residential use. Good quality with reliable performance for standard applications.',
      price: 1400,
      category: 'window-frames',
      images: ['/images/products/1.png'],
      featured: false,
      inStock: true,
      specifications: {
        material: 'Galvanised Iron',
        grade: 'Standard Grade',
        thickness: '0.8mm',
        finish: 'Galvanised',
        warranty: '6 Years'
      },
      createdAt: new Date('2024-02-15').toISOString()
    },
    {
      _id: '6',
      name: 'Commercial Ventilation Unit',
      description: 'Large-scale ventilation systems for commercial buildings. Designed for optimal air circulation and energy efficiency.',
      price: 2800,
      category: 'ventilation',
      images: ['/images/products/2.png'],
      featured: true,
      inStock: false,
      specifications: {
        material: 'Commercial Grade GI',
        grade: 'Heavy Duty',
        capacity: 'High Volume',
        finish: 'Corrosion Resistant',
        warranty: '7 Years'
      },
      createdAt: new Date('2024-02-20').toISOString()
    }
  ],
  
  blogs: [
    {
      _id: 'blog1',
      title: 'Why Galvanised Iron is the Future of Construction',
      slug: 'why-galvanised-iron-future-construction',
      content: 'Galvanised iron has revolutionized the construction industry with its superior corrosion resistance and durability. In this comprehensive guide, we explore why GI products are becoming the preferred choice for modern construction projects.\n\nThe galvanisation process involves coating iron or steel with a protective layer of zinc, which acts as a barrier against corrosion. This makes GI products ideal for use in harsh weather conditions and coastal areas where salt exposure is common.\n\nKey benefits of galvanised iron include:\n- Superior corrosion resistance\n- Long-lasting durability\n- Cost-effective maintenance\n- Environmental sustainability\n- Excellent strength-to-weight ratio\n\nAt Happy Steels, we use the latest hot-dip galvanising technology to ensure our products meet the highest quality standards.',
      excerpt: 'Discover why galvanised iron is becoming the preferred choice for modern construction projects and how it offers superior durability and cost-effectiveness.',
      author: { name: 'Arpit Kumar' },
      category: 'Industry Insights',
      tags: ['galvanised iron', 'construction', 'durability', 'corrosion resistance'],
      featured: true,
      featuredImage: { url: '/images/products/1.png' },
      publishedAt: new Date('2024-03-01').toISOString(),
      createdAt: new Date('2024-03-01').toISOString()
    },
    {
      _id: 'blog2',
      title: 'Maintenance Tips for GI Door and Window Frames',
      slug: 'maintenance-tips-gi-door-window-frames',
      content: 'Proper maintenance of galvanised iron door and window frames ensures longevity and optimal performance. Here are expert tips to keep your GI frames in perfect condition.\n\n**Regular Cleaning:**\nClean your GI frames every 3-6 months with mild soap and water. Avoid abrasive cleaners that can damage the galvanised coating.\n\n**Inspection Schedule:**\nPerform visual inspections quarterly to check for any signs of wear, damage, or corrosion. Early detection helps prevent major issues.\n\n**Lubrication:**\nApply appropriate lubricants to moving parts like hinges and locks every 6 months to ensure smooth operation.\n\n**Professional Servicing:**\nSchedule professional maintenance annually for comprehensive inspection and servicing.\n\nFollowing these simple maintenance practices can extend the life of your GI frames by several years.',
      excerpt: 'Learn essential maintenance tips to keep your galvanised iron door and window frames in perfect condition for years to come.',
      author: { name: 'Vikas Sharma' },
      category: 'Maintenance Guide',
      tags: ['maintenance', 'GI frames', 'door frames', 'window frames'],
      featured: false,
      featuredImage: { url: '/images/products/2.png' },
      publishedAt: new Date('2024-03-10').toISOString(),
      createdAt: new Date('2024-03-10').toISOString()
    },
    {
      _id: 'blog3',
      title: 'Choosing the Right GI Frame for Your Project',
      slug: 'choosing-right-gi-frame-project',
      content: 'Selecting the appropriate galvanised iron frame for your construction project requires careful consideration of various factors. This guide will help you make the right choice.\n\n**Project Type Considerations:**\n- Residential buildings: Standard grade GI frames\n- Commercial buildings: Heavy-duty frames\n- Coastal areas: Extra corrosion-resistant variants\n- Industrial facilities: Specialized heavy-duty options\n\n**Key Selection Criteria:**\n1. Environmental conditions\n2. Load requirements\n3. Security needs\n4. Budget constraints\n5. Aesthetic preferences\n\n**Quality Standards:**\nAlways ensure your GI frames meet IS 1079 standards for quality and safety. Look for proper certification and warranty coverage.\n\nOur team at Happy Steels can help you select the perfect GI frames for your specific requirements.',
      excerpt: 'Complete guide to selecting the right galvanised iron frames for your construction project based on various factors and requirements.',
      author: { name: 'Arpit Kumar' },
      category: 'Buyer\'s Guide',
      tags: ['selection guide', 'GI frames', 'construction', 'quality standards'],
      featured: true,
      featuredImage: { url: '/images/products/1.png' },
      publishedAt: new Date('2024-03-15').toISOString(),
      createdAt: new Date('2024-03-15').toISOString()
    }
  ],
  
  contacts: [
    {
      _id: 'contact1',
      name: 'Rajesh Sharma',
      email: 'rajesh@example.com',
      phone: '+91 98765 43210',
      subject: 'Bulk Order Inquiry',
      message: 'I need a quote for 100 door frames for my residential project.',
      status: 'New',
      createdAt: new Date('2024-03-01').toISOString()
    },
    {
      _id: 'contact2',
      name: 'Priya Singh',
      email: 'priya@example.com',
      phone: '+91 87654 32109',
      subject: 'Product Information',
      message: 'Please provide details about your ventilation systems.',
      status: 'Replied',
      createdAt: new Date('2024-03-05').toISOString()
    }
  ],
  
  admins: [
    {
      _id: 'admin1',
      name: 'Arpit Kumar',
      username: 'admin',
      email: 'admin@happysteels.com',
      password: 'admin123', // In real app, this would be hashed
      role: 'super_admin',
      status: 'active',
      createdAt: new Date('2024-01-01').toISOString()
    }
  ],
  
  workers: [
    {
      _id: 'worker1',
      name: 'Vikas Sharma',
      email: 'vikas@happysteels.com',
      password: 'worker123', // In real app, this would be hashed
      role: 'production_manager',
      status: 'active',
      createdAt: new Date('2024-01-01').toISOString()
    }
  ]
};

// Utility functions
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const generateId = () => {
  return Date.now().toString() + Math.random().toString(36).substr(2, 9);
};

const mockApiCall = async (data, pagination = null) => {
  // Simulate network delay
  await delay(Math.random() * 500 + 200);
  const response = {
    data: {
      success: true,
      data: data
    }
  };
  
  if (pagination) {
    response.data.pagination = pagination;
  }
  
  return response;
};

const mockApiError = async (message) => {
  await delay(Math.random() * 300 + 100);
  throw new Error(message);
};

// Products API
export const productsAPI = {
  // Get all products with optional filters
  getAll: async (params = {}) => {
    try {
      let products = [...mockData.products];
      
      // Apply filters
      if (params.category) {
        products = products.filter(p => p.category === params.category);
      }
      
      if (params.featured !== undefined) {
        products = products.filter(p => p.featured === params.featured);
      }
      
      if (params.search) {
        const searchTerm = params.search.toLowerCase();
        products = products.filter(p => 
          p.name.toLowerCase().includes(searchTerm) ||
          p.description.toLowerCase().includes(searchTerm) ||
          p.category.toLowerCase().includes(searchTerm)
        );
      }
      
      if (params.minPrice !== undefined) {
        products = products.filter(p => p.price >= params.minPrice);
      }
      
      if (params.maxPrice !== undefined) {
        products = products.filter(p => p.price <= params.maxPrice);
      }
      
      if (params.inStock !== undefined) {
        products = products.filter(p => p.inStock === params.inStock);
      }
      
      // Apply sorting
      if (params.sortBy) {
        switch (params.sortBy) {
          case 'price_asc':
            products.sort((a, b) => a.price - b.price);
            break;
          case 'price_desc':
            products.sort((a, b) => b.price - a.price);
            break;
          case 'name_asc':
            products.sort((a, b) => a.name.localeCompare(b.name));
            break;
          case 'name_desc':
            products.sort((a, b) => b.name.localeCompare(a.name));
            break;
          case 'newest':
            products.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            break;
          case 'oldest':
            products.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            break;
          default:
            break;
        }
      }
      
      // Calculate pagination if requested
      if (params.page || params.limit) {
        const page = parseInt(params.page) || 1;
        const limit = parseInt(params.limit) || 12;
        const totalItems = products.length;
        const totalPages = Math.ceil(totalItems / limit);
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        
        // Apply pagination
        const paginatedProducts = products.slice(startIndex, endIndex);
        
        const pagination = {
          currentPage: page,
          totalPages: totalPages,
          totalItems: totalItems,
          hasNext: page < totalPages,
          hasPrev: page > 1
        };
        
        return mockApiCall(paginatedProducts, pagination);
      }
      
      // Apply simple limit without pagination
      if (params.limit && !params.page) {
        products = products.slice(0, params.limit);
      }
      
      return mockApiCall(products);
    } catch (error) {
      return mockApiError('Failed to fetch products');
    }
  },

  // Get product by ID
  getById: async (id) => {
    try {
      const product = mockData.products.find(p => p._id === id);
      if (!product) {
        throw new Error('Product not found');
      }
      return mockApiCall(product);
    } catch (error) {
      return mockApiError('Product not found');
    }
  },

  // Create new product (admin only)
  create: async (productData) => {
    try {
      const newProduct = {
        _id: generateId(),
        ...productData,
        createdAt: new Date().toISOString()
      };
      mockData.products.push(newProduct);
      return mockApiCall(newProduct);
    } catch (error) {
      return mockApiError('Failed to create product');
    }
  },

  // Update product (admin only)
  update: async (id, productData) => {
    try {
      const index = mockData.products.findIndex(p => p._id === id);
      if (index === -1) {
        throw new Error('Product not found');
      }
      mockData.products[index] = { ...mockData.products[index], ...productData };
      return mockApiCall(mockData.products[index]);
    } catch (error) {
      return mockApiError('Failed to update product');
    }
  },

  // Delete product (admin only)
  delete: async (id) => {
    try {
      const index = mockData.products.findIndex(p => p._id === id);
      if (index === -1) {
        throw new Error('Product not found');
      }
      mockData.products.splice(index, 1);
      return mockApiCall({ message: 'Product deleted successfully' });
    } catch (error) {
      return mockApiError('Failed to delete product');
    }
  }
};

// Blogs API
export const blogsAPI = {
  // Get all blogs with optional filters
  getAll: async (params = {}) => {
    try {
      let blogs = [...mockData.blogs];
      
      // Apply filters
      if (params.category) {
        blogs = blogs.filter(b => b.category === params.category);
      }
      
      if (params.featured !== undefined) {
        blogs = blogs.filter(b => b.featured === params.featured);
      }
      
      if (params.search) {
        const searchTerm = params.search.toLowerCase();
        blogs = blogs.filter(b => 
          b.title.toLowerCase().includes(searchTerm) ||
          b.content.toLowerCase().includes(searchTerm) ||
          b.category.toLowerCase().includes(searchTerm) ||
          b.tags.some(tag => tag.toLowerCase().includes(searchTerm))
        );
      }
      
      // Apply sorting (newest first by default)
      if (params.sort === 'newest' || !params.sort) {
        blogs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      } else if (params.sort === 'popular') {
        // For demo purposes, just sort by featured status
        blogs.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
      } else if (params.sort === 'title') {
        blogs.sort((a, b) => a.title.localeCompare(b.title));
      }
      
      // Calculate pagination
      const page = parseInt(params.page) || 1;
      const limit = parseInt(params.limit) || 9;
      const totalItems = blogs.length;
      const totalPages = Math.ceil(totalItems / limit);
      const startIndex = (page - 1) * limit;
      const endIndex = startIndex + limit;
      
      // Apply pagination
      const paginatedBlogs = blogs.slice(startIndex, endIndex);
      
      const pagination = {
        currentPage: page,
        totalPages: totalPages,
        totalItems: totalItems,
        hasNext: page < totalPages,
        hasPrev: page > 1
      };
      
      return mockApiCall(paginatedBlogs, pagination);
    } catch (error) {
      return mockApiError('Failed to fetch blogs');
    }
  },

  // Get blog by ID
  getById: async (id) => {
    try {
      const blog = mockData.blogs.find(b => b._id === id);
      if (!blog) {
        throw new Error('Blog not found');
      }
      return mockApiCall(blog);
    } catch (error) {
      return mockApiError('Blog not found');
    }
  },

  // Create new blog (admin only)
  create: async (blogData) => {
    try {
      const newBlog = {
        _id: generateId(),
        ...blogData,
        createdAt: new Date().toISOString()
      };
      mockData.blogs.push(newBlog);
      return mockApiCall(newBlog);
    } catch (error) {
      return mockApiError('Failed to create blog');
    }
  },

  // Update blog (admin only)
  update: async (id, blogData) => {
    try {
      const index = mockData.blogs.findIndex(b => b._id === id);
      if (index === -1) {
        throw new Error('Blog not found');
      }
      mockData.blogs[index] = { ...mockData.blogs[index], ...blogData };
      return mockApiCall(mockData.blogs[index]);
    } catch (error) {
      return mockApiError('Failed to update blog');
    }
  },

  // Delete blog (admin only)
  delete: async (id) => {
    try {
      const index = mockData.blogs.findIndex(b => b._id === id);
      if (index === -1) {
        throw new Error('Blog not found');
      }
      mockData.blogs.splice(index, 1);
      return mockApiCall({ message: 'Blog deleted successfully' });
    } catch (error) {
      return mockApiError('Failed to delete blog');
    }
  }
};

// Contact API
export const contactAPI = {
  // Submit contact form
  submit: async (contactData) => {
    try {
      const newContact = {
        _id: generateId(),
        ...contactData,
        status: 'New',
        createdAt: new Date().toISOString()
      };
      mockData.contacts.push(newContact);
      return mockApiCall({ message: 'Contact form submitted successfully' });
    } catch (error) {
      return mockApiError('Failed to submit contact form');
    }
  },

  // Get all contacts (admin only)
  getAll: async () => {
    try {
      return mockApiCall(mockData.contacts);
    } catch (error) {
      return mockApiError('Failed to fetch contacts');
    }
  },

  // Update contact status (admin only)
  updateStatus: async (id, status) => {
    try {
      const index = mockData.contacts.findIndex(c => c._id === id);
      if (index === -1) {
        throw new Error('Contact not found');
      }
      mockData.contacts[index].status = status;
      return mockApiCall(mockData.contacts[index]);
    } catch (error) {
      return mockApiError('Failed to update contact status');
    }
  }
};

// Admin API
export const adminAPI = {
  // Admin login
  login: async (credentials) => {
    try {
      const { username, password } = credentials;
      const admin = mockData.admins.find(a => 
        a.username === username && a.password === password && a.status === 'active'
      );
      
      if (!admin) {
        throw new Error('Invalid credentials');
      }
      
      // Return admin data without password
      const { password: _, ...adminData } = admin;
      return mockApiCall({ admin: adminData, token: 'mock-jwt-token' });
    } catch (error) {
      return mockApiError('Invalid credentials');
    }
  },

  // Admin signup
  signup: async (signupData) => {
    try {
      // Check if username already exists
      const existingAdmin = mockData.admins.find(a => a.username === signupData.username);
      if (existingAdmin) {
        throw new Error('Username already exists');
      }
      
      const newAdmin = {
        _id: generateId(),
        ...signupData,
        role: 'admin',
        status: 'active',
        createdAt: new Date().toISOString()
      };
      
      mockData.admins.push(newAdmin);
      
      // Return admin data without password
      const { password: _, ...adminData } = newAdmin;
      return mockApiCall({ admin: adminData, token: 'mock-jwt-token' });
    } catch (error) {
      return mockApiError(error.message || 'Failed to create admin account');
    }
  }
};

// Worker API
export const workerAPI = {
  // Worker login
  login: async (credentials) => {
    try {
      const { email, password } = credentials;
      const worker = mockData.workers.find(w => 
        w.email === email && w.password === password && w.status === 'active'
      );
      
      if (!worker) {
        throw new Error('Invalid credentials');
      }
      
      // Return worker data without password
      const { password: _, ...workerData } = worker;
      return mockApiCall({ worker: workerData, token: 'mock-jwt-token' });
    } catch (error) {
      return mockApiError('Invalid credentials');
    }
  }
};

// Export mockData for testing purposes
export { mockData };
